import { FC, useState } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Box from '@mui/material/Box'
import Button from '@mui/lab/LoadingButton'
import { Text } from 'entities/Text'
import { signIn, AuthErrors } from 'shared/helpers/signIn'
import { Input } from 'entities/Input'
import { consoleError } from 'shared/helpers/consoleError'

export const LoginComponent: FC<ILoginComponent> = ({ moveToMFA }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      setIsLoading(true)
      const data = new FormData(event.currentTarget)
      const user = data.get('email') || ''
      const password = data.get('password') || ''
      const result = await signIn({ user: user as string, password: password as string })
      if (result?.[0] === AuthErrors.MFA_REQUIRED) {
        moveToMFA(result?.[1])
      }
    } catch (e) {
      setIsLoading(false)
      consoleError(`Log in Error:, ${e}`)
    }
  }

  return (
    <>
      <Text component='h1' variant='h5'>
        Sign in
      </Text>
      <Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <Input
          autoFocus
          margin='normal'
          required
          fullWidth
          id='email'
          label='Email Address'
          name='email'
          autoComplete='email'
        />
        <Input
          margin='normal'
          required
          fullWidth
          name='password'
          label='Password'
          type='password'
          id='password'
          autoComplete='current-password'
        />
        <FormControlLabel
          control={<Checkbox value='remember' color='primary' />}
          label='Remember me'
        />
        <Button
          type='submit'
          fullWidth
          variant='contained'
          sx={{ mt: 3, mb: 2 }}
          loading={isLoading}
          color='warning'
        >
          Sign In
        </Button>
        {/* <Grid container>
          <Grid item xs>
            <Link href='#' variant='body2'>
              Forgot password?
            </Link>
          </Grid>
          <Grid item>
            <Link href='#' variant='body2'>
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid> */}
      </Box>
    </>
  )
}

interface ILoginComponent {
  moveToMFA: (user: any) => void
}
